<script>
import { products } from '@site/data/products'
import { company } from '@site/data/company'
import { CONTACT } from '@site/data/contact'

export default {
  name: 'SiteFooter',
  data() {
    return { products, company, CONTACT }
  },
}
</script>

<template>
  <footer class="site-footer">
    <div class="container">
      <div class="site-footer__top">
        <div class="site-footer__brand">
          <div class="site-footer__logo">
            <span class="site-footer__logo-mark">航</span>
            <strong>航富通</strong>
          </div>
          <p>为文创、饰品、潮玩、谷子、服装、珠宝、美妆、手作、杂货门店打造的开单收银与门店管理利器。</p>
        </div>

        <div class="site-footer__col">
          <h4>产品</h4>
          <router-link v-for="p in products" :key="p.type" :to="p.link">{{ p.name }}</router-link>
          <router-link to="/compare">套餐对比</router-link>
        </div>

        <div class="site-footer__col">
          <h4>关于</h4>
          <router-link to="/about">关于我们</router-link>
          <router-link to="/about">隐私政策</router-link>
        </div>

        <div class="site-footer__col">
          <h4>联系方式</h4>
          <span>{{ CONTACT.phone1.name }} {{ CONTACT.phone1.tel }}</span>
          <span>{{ CONTACT.serviceHours }}</span>
          <span>{{ CONTACT.address }}</span>
        </div>
      </div>

      <div class="site-footer__bottom">
        <span>{{ company.copyright }}</span>
        <span>{{ company.beian }}</span>
        <span class="site-footer__company">{{ company.name }}</span>
      </div>
    </div>
  </footer>
</template>


<style lang="scss" scoped>
.site-footer {
  background: $color-dark;
  color: rgba(255, 255, 255, 0.75);
  padding: 64px 0 32px;

  &__top {
    display: grid;
    grid-template-columns: 1.5fr 1fr 1fr 1.2fr;
    gap: $space-gap;
    padding-bottom: 40px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  }

  &__brand {
    p { margin-top: 16px; line-height: 1.8; font-size: 14px; max-width: 280px; }
  }

  &__logo {
    display: flex;
    align-items: center;
    gap: 10px;
    color: $color-white;
    font-size: 20px;

    &-mark {
      width: 36px;
      height: 36px;
      border-radius: 10px;
      background: $gradient-brand;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  &__col {
    display: flex;
    flex-direction: column;
    gap: 12px;

    h4 { color: $color-white; font-size: 16px; margin-bottom: 6px; }

    a, span {
      color: rgba(255, 255, 255, 0.7);
      font-size: 14px;
      line-height: 1.6;
      transition: color 0.2s;
      &:hover { color: $color-secondary-light; }
    }
  }

  &__bottom {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    align-items: center;
    justify-content: space-between;
    padding-top: 24px;
    font-size: 13px;
    color: rgba(255, 255, 255, 0.5);
  }

  &__company { opacity: 0.7; }

  @media (max-width: $bp-sm) {
    &__top { grid-template-columns: 1fr; gap: 28px; }
    &__bottom { flex-direction: column; text-align: center; gap: 8px; }
  }
}
</style>



// WEBPACK FOOTER //
// src/site/components/layout/SiteFooter.vue